module.exports = "<svg id=\"facebook\" viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\">\n\t<path d=\"M7.003 17l-.006-7H4l.006-3h2.997V4.995C7.003 2.408 8.457 1 10.808 1c1.126 0 1.91.082 2.192.12v2.877h-1.447c-1.278 0-1.526.597-1.526 1.472V7h2.866l-.403 3h-2.47l.007 7H7.003z\"/>\n</svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./theroot/root-100-2019/src/img/facebook.svg
// module id = 207
// module chunks = 0